let appConfig;

export default function getConfig() {
  if (!appConfig) {
    const inlineJsonElement = document.querySelector(
      `script[type="application/json"][data-selector="unthread-config"]`
    );

    appConfig = JSON.parse(inlineJsonElement.textContent);
  }

  return appConfig;
}
